import React, { useContext } from 'react'

import { Boleto } from '../../../../../../../../../services/boleto'
import { can } from '../../../../../../../../../config/permissions'
import { PaginationContext } from '../../../../../../../../../contexts/PaginationContext'
import { Button } from '../../../../../../../../../components/Button'
import { Show } from '../../../../../../../../../components/Show'
import { numberToCurrency } from '../../../../../../../../../utils/number'
import { dateToLocaleDate } from '../../../../../../../../../utils/date'

import { AccountFormatted } from '../../../../../../../utils/formatAccount'
import { useBoleto } from '../../../../../hooks'

interface BoletoRefreshActionProps {
  account: AccountFormatted
  onRefresh: (account: AccountFormatted) => void
}

export const BoletoRefreshAction: React.FC<BoletoRefreshActionProps> = ({
  account,
  onRefresh
}) => {
  const { pagination } = useContext(PaginationContext)
  const { loading, refreshBoleto } = useBoleto()

  function updateAccountList(boleto: Boleto) {
    const { statusDate: paymentDate, paidValue: amountPaid } = boleto
    const update = {
      ...account,
      paymentDate,
      amountPaid,
      paymentDateFormatted: dateToLocaleDate(paymentDate),
      amountPaidFormatted: numberToCurrency(amountPaid),
      boleto
    }
    onRefresh(update)
  }

  function handleButtonClick() {
    const { orderId } = account

    if (!orderId) return

    refreshBoleto(orderId, account.id, boleto => {
      updateAccountList(boleto)
    })
  }

  const isBoletoReceivable =
    account.paymentType === 'BOLETO' && pagination.query.type === 'RECEIVABLE'
  const accountIsPaid = account.isPaid

  return (
    <Show condition={isBoletoReceivable && !accountIsPaid}>
      <Button
        icon="refresh"
        size="mini"
        disabled={loading}
        onClick={handleButtonClick}
        loading={loading}
        can={can.boleto.updateStatus}
        popup="Atualizar boleto"
        invertedPopup
        circular
      />
    </Show>
  )
}
